module.exports = __webpack_public_path__ + "static/media/icon_speaker_white.ee57aa94.svg";